import React from 'react';
import '../styles/AboutUs.css';
import { FaBullseye, FaShieldAlt, FaGlobeAmericas, FaLightbulb, FaCheckCircle } from 'react-icons/fa';

function AboutUs() {
  return (
    <div className="about-page">
      <header className="about-hero">
        <div className="about-hero-content">
          <h1>About Global Tongue</h1>
          <p>Bridging Language and Culture with Precision</p>
        </div>
      </header>

      <section className="about-section">
        <div className="about-container">
          <h2><FaBullseye className="about-icon" /> Our Mission</h2>
          <p>
            At Global Tongue, we are committed to breaking communication barriers by providing world-class translation,
            localization, and interpreting services. Our goal is to empower clients to reach diverse audiences with clarity
            and cultural sensitivity.
          </p>
        </div>
      </section>

      <section className="about-section gray">
        <div className="about-container">
          <h2><FaShieldAlt className="about-icon" /> Our Core Values</h2>
          <ul className="values-list">
            <li><FaCheckCircle className="value-icon" /> <strong>Accuracy</strong> — We ensure precise and professional language services.</li>
            <li><FaCheckCircle className="value-icon" /> <strong>Confidentiality</strong> — Your privacy and data security are our priority.</li>
            <li><FaGlobeAmericas className="value-icon" /> <strong>Cultural Competence</strong> — We understand the importance of context and nuance.</li>
            <li><FaLightbulb className="value-icon" /> <strong>Innovation</strong> — We use advanced tools for efficiency and quality control.</li>
          </ul>
        </div>
      </section>

    </div>
  );
}

export default AboutUs;
